module.exports = __webpack_public_path__ + "static/media/example-1.55c4872e.png";